export default "__VITE_ASSET__Dra9hGx9__"